<template>
  <div>
    <div class="loader-cont">
      <div class="loader-cont__wrapper">
        <div class="loader"></div>
        <div class="loader_text">{{ getTranslations.home_loader_please_wait }}</div>
      </div>
    </div>

    <maintenance v-if=serverUnderMaintenance></maintenance>
  </div>
</template>

<script>
/* eslint no-console: "off", no-use-before-define: ["error", { "variables": false }] */
import { mapState, mapGetters, mapMutations } from 'vuex';
import webSocket from '@/common/webSocket';
import auth from '@/common/auth';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import Maintenance from '@/components/home/modals/Maintenance';

export default {
  name: 'searching-opponent',
  props: ['gameType'],
  mixins: [ParseResponseMixin, GameMixin2],
  components: {
    Maintenance,
  },
  watch: {
    stompClient: {
      handler() {
        console.log('change to stompclient!');
        // eslint-disable-next-line
        console.log('connected: ' + this.stompClient.connected);
        if (this.stompClient.connected) this.hasConnectAtLeastOneTime = true;
        else if (this.hasConnectAtLeastOneTime) this.OnStompClientFailure('lock screen error');
      },
      deep: true,
    },
  },
  data() {
    return {
      hasConnectAtLeastOneTime: false,
      stompClient: null,
      subscription: null,
      timer: null,
      connectionTimer: null,
      serverUnderMaintenance: false,
    };
  },
  created() {
    console.log('in SearchingOpponent created hook');
    // resetting game state
    this.resetGameState();
    this.setGameInProgress(true);
    this.setTransitionOnlyForSearchingToOpponent(true);
    this.callToInitiate();
    this.stompClient = webSocket.getGameStompClient();
    if (this.stompClient === null || !this.stompClient.connected) {
      this.stompClient = webSocket.createNewStompClient('/gameData');
    }
    console.log('this.stompClient:', this.stompClient);
    this.findOpponent();
  },
  beforeDestroy() {
    console.log('in searchingOpponet\'s beforeDestroy hook');
    // if for any reason we leave this component earlier from the websocket's response,
    // unsubscribe from the subscribed channels
    this.subscription = null;
  },
  methods: {
    ...mapMutations('game', [
      'setTransitionOnlyForSearchingToOpponent',
      'resetGameState',
      'setGameInProgress',
      'setGameID',
      'setGameCardDTOS',
      'setGameAttempts',
      'setGameType',
      'setShuffledCardDTOS',
    ]),
    OnStompClientFailure(error) {
      console.log(error);
      window.location.reload();
    },
    callToInitiate() {
      return this.$axios({
        url: `api/randomMatchingForTreasureIsland?gameType=${this.gameType}`,
        method: 'GET',
        headers: {
          Authorization: this.jwtInVuex,
        },
      }).then((response) => {
        const responseData = response.data;
        if (responseData.responseEnum === 'EVENT_LOCKED' || responseData.responseEnum === 'NO_AVAILABLE_GAMES') {
          this.serverUnderMaintenance = true;
          this.showHideModal();
        }
      }).catch((error) => {
        console.log(`Invoking api/randomMatchingForTreasureIsland failed with the following error: ${error}`);
      });
    },
    findOpponent() {
      const stompSuccess = (frame) => {
        clearTimeout(this.connectionTimer);
        // console.clear();
        console.log(`In SearchingOpponent component: ${frame}`);
        console.log(`Subscribing to channel: /topic/ctasFetched/${this.userDetails.msisdn}`);
        this.subscription = this.stompClient.subscribe(`/topic/ctasFetched/${this.userDetails.msisdn}`, (response) => {
          console.log('[SearchingOpponent] Inside gameFound response');
          // parse server response and return if any errors occur
          const responseData = this.parseServerResponse(response.body);
          if (responseData === null) {
            return;
          }
          console.log('responseData:', responseData);
          this.subscription.unsubscribe();
          console.log('gameStateEnum: OPPONENT_FOUND');
          this.saveResponseData(responseData);
          this.normalTransition = true;
          console.log('going to opponent found page...');
          console.log(responseData.gameDTO.gameType);
          if (responseData.gameDTO.gameType === 'MW') {
            this.$router.replace('/memoryWizard');
          } else if (responseData.gameDTO.gameType === 'ODD') {
            this.$router.replace('/oddObject');
          } else if (responseData.gameDTO.gameType === 'SD') {
            this.$router.replace('/spotDifference');
          }
        }, (errorResponse) => {
          console.error(`Error response: ${errorResponse}`);
        });
      };

      const stompFailure = (error) => {
        console.error(`Connect failed with the following error: ${error.headers.message}`);
        console.log(this.$router.currentRoute);
        if (this.$router.currentRoute.path === '/searchingOpponent') {
          console.info('Lost connection to WebSocket! Reconnecting in 3 seconds...');
          clearTimeout(this.connectionTimer);
          this.connectionTimer = setTimeout(() => {
            this.stompClient = webSocket.createNewStompClient('/gameData');
            connect();
          }, 3000);
        }
      };

      const connect = (() => {
        if (!this.stompClient.connected) {
          this.stompClient.connect({ Authorization: auth.getJwt() }, stompSuccess, stompFailure);
        } else {
          stompSuccess();
        }
      })();
    },
    saveResponseData(responseData) {
      console.log(responseData);
      this.setGameID(responseData.gameDTO.id);
      this.setGameCardDTOS(responseData.gameDTO);
      this.setGameAttempts(responseData.gameDTO);
      this.setGameType(responseData.gameDTO);
      this.setShuffledCardDTOS(responseData);
    },
    showHideModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          this.setGameInProgress(false);
          this.setTransitionOnlyForSearchingToOpponent(false);
          this.$router.push('/home');
        });

        $('.modal,.modal-overlay').fadeIn(200);
        /* eslint-enable */
      });
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/SearchingOpponent.vue